document.addEventListener('htmx:configRequest', (event) => {
  if(event.detail.verb === "get") return

  const csrfTokenTag = document.querySelector('[name="csrf-token"]')
  if(csrfTokenTag === null) return

  const csrfToken = csrfTokenTag.content
  event.detail.headers["X-CSRF-Token"] = csrfToken
})
